import { SVGProps } from 'react';

const AccordionArrowIcon = (props: SVGProps<SVGSVGElement>) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="100%"
			height="100%"
			viewBox="0 0 10 6"
			fill="none"
			{...props}
		>
			<path
				d="M4.67647 5.82157L0.131248 1.27635C0.0890179 1.23412 0.0555201 1.18399 0.0326653 1.12881C0.00981045 1.07363 -0.00195312 1.0145 -0.00195312 0.954775C-0.00195312 0.895053 0.00981045 0.835916 0.0326653 0.78074C0.0555201 0.725564 0.0890179 0.67543 0.131248 0.6332C0.173477 0.590971 0.223612 0.557472 0.278788 0.534617C0.333963 0.511763 0.393101 0.5 0.452823 0.5C0.512545 0.5 0.571682 0.511763 0.626858 0.534617C0.682034 0.557472 0.732168 0.590971 0.774398 0.6332L4.99805 4.85742L9.2217 0.6332C9.30698 0.547913 9.42266 0.5 9.54327 0.5C9.66389 0.5 9.77956 0.547913 9.86485 0.6332C9.95013 0.718487 9.99805 0.834161 9.99805 0.954775C9.99805 1.07539 9.95013 1.19106 9.86485 1.27635L5.31962 5.82157C5.27741 5.86383 5.22728 5.89736 5.1721 5.92023C5.11692 5.94311 5.05778 5.95488 4.99805 5.95488C4.93832 5.95488 4.87917 5.94311 4.82399 5.92023C4.76881 5.89736 4.71869 5.86383 4.67647 5.82157Z"
				fill="currentColor"
			/>
		</svg>
	);
};

export default AccordionArrowIcon;
